import axios from "axios";
import { sisikong_url } from "../../api";
import type { WebSocketMessage } from "./types";

// WebSocket URL - convert http/https to ws/wss
function getWebSocketUrl(): string {
  const baseUrl = sisikong_url;
  if (baseUrl.startsWith("https://")) {
    return baseUrl.replace("https://", "wss://");
  }
  if (baseUrl.startsWith("http://")) {
    return baseUrl.replace("http://", "ws://");
  }
  return baseUrl;
}

export const WS_BASE_URL = getWebSocketUrl();

/**
 * Get the websocket URL for a quotation chat session
 * Following fastchat pattern: /ws/chat-rooms/{room_uid}/member-sessions/{member_session_uid}
 * The member_session_uid format is: member_session_{uuid}___{email}
 */
export function getQuotationChatWebSocketUrl(roomUid: string, memberSessionUid: string): string {
  return `${WS_BASE_URL}/fastchat/ws/chat-rooms/${roomUid}/member-sessions/${memberSessionUid}`;
}

/**
 * Get chat room messages by room UID
 */
export function getChatRoomMessages(room_uid: string): Promise<{ data: WebSocketMessage[] }> {
  const url = `${sisikong_url}/fastchat/api/v1/messages-by-chat-room/${room_uid}`;
  return axios.get(url);
}

/**
 * Fetch a single quotation request by ID
 * @param id - The quotation request ID
 */
export function fetchQuotationRequest({ id }: { id: string | number }): Promise<{ data: any }> {
  const url = `${sisikong_url}/crs/quotation-request/${id}/`;
  return axios.get(url);
}

/**
 * Response type for getting a quotation request by reference
 */
export interface GetQuotationRequestByReferenceResponse {
  reference: string;
  title: string | null;
  status: string;
  status_display: string;
  source_entity: string | null;
  target_entity: string | null;
  trip_start_date: string | null;
  trip_end_date: string | null;
  adults: number | null;
  children: number | null;
  created: string;
  due_date: string | null;
  sent_date: string | null;
  assign_date: string | null;
  client_message: string | null;
  chat_session_uid: string | null;
}

/**
 * Fetch a quotation request by reference using apollob2b authentication
 * @param reference - The quotation request reference
 * @param token - The authentication token
 */
export function getQuotationRequestByReference({
  reference,
  token,
}: {
  reference: string;
  token: string;
}): Promise<{ data: GetQuotationRequestByReferenceResponse }> {
  return axios.get(`${sisikong_url}/crs/external/quotationrequest/by-reference/`, {
    params: { reference },
    headers: { Authorization: `Bearer ${token}` },
  });
}
